/**
 * Shared timing constants used across the application.
 */

/** Maximum age (ms) before cache is considered stale and triggers a full sync. */
export const CACHE_MAX_AGE_MS = 5 * 60 * 1000; // 5 minutes

/** Interval (ms) between periodic full-sync safety-net runs. */
export const PERIODIC_SYNC_INTERVAL_MS = 15 * 60 * 1000; // 15 minutes

/** Interval (ms) between periodic auth session health checks. */
export const SESSION_CHECK_INTERVAL_MS = 5 * 60 * 1000; // 5 minutes

/** Number of tasks fetched per Supabase query page. */
export const TASK_PAGE_LIMIT = 1000;

/** Debounce (ms) for real-time task INSERT subscription reload. */
export const REALTIME_INSERT_DEBOUNCE_MS = 300;

/** Stale threshold (ms) for space items cache. */
export const SPACE_ITEMS_CACHE_MAX_AGE_MS = 5 * 60 * 1000; // 5 minutes
